import { useFormContext } from "react-hook-form"
import { FormField, FormItem } from "~/shadcn/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/shadcn/ui/select"
import { SearchValues } from "../schema"

const OPTIONS = {
  any: { label: "Any media kit", value: undefined },
  published: { label: "Media kit published", value: true },
  unpublished: { label: "Media kit not published", value: false },
} as const satisfies Record<
  string,
  { label: string; value: boolean | undefined }
>

type OptionKey = keyof typeof OPTIONS

const isOptionKey = (key: string): key is OptionKey => key in OPTIONS

const optionKeyFor = (value: boolean | undefined): OptionKey => {
  switch (value) {
    case undefined:
      return "any"
    case true:
      return "published"
    case false:
      return "unpublished"
  }
}

export const PublicMediaKitFilter = ({
  onChange,
}: {
  onChange: () => void
}) => {
  const form = useFormContext<SearchValues>()

  return (
    <FormField
      control={form.control}
      name="publicMediaKitEnabled"
      render={({ field }) => (
        <FormItem>
          <Select
            value={optionKeyFor(field.value)}
            onValueChange={(key) => {
              if (!isOptionKey(key)) throw new Error(`Unknown option ${key}`)
              field.onChange(OPTIONS[key].value)
              onChange()
            }}
          >
            <SelectTrigger aria-label="Filter by media kit" className="h-12">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {Object.entries(OPTIONS).map(([key, option]) => (
                <SelectItem key={key} value={key}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormItem>
      )}
    />
  )
}
